/* TIBIA — interacciones propias (prefijo tb-) */
(function () {
  'use strict';
  var reducir = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveals al hacer scroll ---------- */
  var observador = null;
  function initReveals(raiz) {
    var els = (raiz || document).querySelectorAll('.tb-reveal:not(.tb-visible)');
    if (!els.length) return;
    if (reducir || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('tb-visible'); });
      return;
    }
    if (!observador) {
      observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('tb-visible');
            observador.unobserve(e.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { observador.observe(el); });
  }

  /* ---------- Cifras animadas ---------- */
  function initContadores(raiz) {
    (raiz || document).querySelectorAll('[data-tb-contar]').forEach(function (el) {
      if (el.dataset.tbListo) return;
      el.dataset.tbListo = '1';
      var fin = parseFloat(el.getAttribute('data-tb-contar')) || 0;
      var ini = parseFloat(el.getAttribute('data-tb-desde')) || 0;
      if (reducir || !('IntersectionObserver' in window)) { el.textContent = fin; return; }
      el.textContent = ini;
      var io = new IntersectionObserver(function (entradas) {
        if (!entradas[0].isIntersecting) return;
        io.disconnect();
        var t0 = null, dur = 2200;
        function paso(t) {
          if (!t0) t0 = t;
          var p = Math.min((t - t0) / dur, 1);
          var ease = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(ini + (fin - ini) * ease);
          if (p < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
      }, { threshold: 0.4 });
      io.observe(el);
    });
  }

  /* ---------- Galería de producto ---------- */
  function initGaleria(raiz) {
    (raiz || document).querySelectorAll('[data-tb-galeria]').forEach(function (gal) {
      var principal = gal.querySelector('[data-tb-principal]');
      if (!principal) return;
      gal.querySelectorAll('[data-tb-mini]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          principal.style.opacity = '0';
          setTimeout(function () {
            principal.src = btn.getAttribute('data-src');
            principal.srcset = btn.getAttribute('data-srcset') || '';
            principal.alt = btn.getAttribute('data-alt') || '';
            principal.style.opacity = '1';
          }, 180);
          gal.querySelectorAll('[data-tb-mini]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
          btn.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  /* ---------- Cantidad ---------- */
  function initCantidad(raiz) {
    (raiz || document).querySelectorAll('.tb-cantidad').forEach(function (c) {
      var input = c.querySelector('input');
      if (!input || c.dataset.tbListo) return;
      c.dataset.tbListo = '1';
      c.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 1;
          v = b.getAttribute('data-dir') === '-' ? Math.max(1, v - 1) : v + 1;
          input.value = v;
        });
      });
    });
  }

  /* ---------- Variantes ---------- */
  function initVariantes(raiz) {
    (raiz || document).querySelectorAll('[data-tb-producto]').forEach(function (wrap) {
      var datos = wrap.querySelector('[data-tb-variantes]');
      if (!datos) return;
      var variantes = JSON.parse(datos.textContent);
      var idInput = wrap.querySelector('input[name="id"]');
      var btns = document.querySelectorAll('[data-tb-boton-comprar="' + wrap.getAttribute('data-tb-producto') + '"]');
      var precio = wrap.querySelector('[data-tb-precio]');
      var antes = wrap.querySelector('[data-tb-precio-antes]');
      var formato = wrap.getAttribute('data-tb-moneda') || '{{amount}} €';
      function dinero(c) {
        var n = (c / 100).toFixed(2).replace('.', ',');
        return formato.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, n);
      }
      wrap.addEventListener('change', function (e) {
        if (!e.target.matches('[data-tb-opcion]')) return;
        var sel = [];
        wrap.querySelectorAll('[data-tb-opcion-grupo]').forEach(function (g) {
          var c = g.querySelector('input:checked');
          sel.push(c ? c.value : null);
        });
        var v = variantes.find(function (x) {
          return x.options.every(function (o, i) { return o === sel[i]; });
        });
        btns.forEach(function (b) {
          b.disabled = !v || !v.available;
          var t = b.querySelector('[data-tb-boton-texto]');
          if (t) t.textContent = !v ? b.getAttribute('data-txt-nodisp') : (v.available ? b.getAttribute('data-txt-ok') : b.getAttribute('data-txt-agotado'));
        });
        if (!v) return;
        if (idInput) idInput.value = v.id;
        if (precio) precio.textContent = dinero(v.price);
        if (antes) {
          antes.textContent = v.compare_at_price > v.price ? dinero(v.compare_at_price) : '';
        }
      });
    });
  }

  /* ---------- Añadir al carrito (abre el carrito de Dawn) ---------- */
  function initCarrito(raiz) {
    (raiz || document).querySelectorAll('form.tb-form-carrito').forEach(function (form) {
      if (form.dataset.tbListo) return;
      form.dataset.tbListo = '1';
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        var boton = form.querySelector('[type="submit"]');
        var aviso = form.parentNode.querySelector('[data-tb-aviso]');
        var drawer = document.querySelector('cart-drawer');
        var noti = document.querySelector('cart-notification');
        var destino = drawer || noti;
        var fd = new FormData(form);
        if (destino && destino.getSectionsToRender) {
          fd.append('sections', destino.getSectionsToRender().map(function (s) { return s.id; }).join(','));
          fd.append('sections_url', window.location.pathname);
        }
        if (boton) boton.setAttribute('aria-busy', 'true');
        if (aviso) aviso.textContent = '';
        fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body: fd
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) {
              if (aviso) aviso.textContent = res.description || res.message || 'No se ha podido añadir.';
              return;
            }
            if (destino && destino.renderContents) {
              if (drawer && drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
              destino.renderContents(res);
            } else {
              window.location = (window.routes && window.routes.cart_url) || '/cart';
            }
          })
          .catch(function () { form.submit(); })
          .finally(function () { if (boton) boton.removeAttribute('aria-busy'); });
      });
    });
    document.querySelectorAll('[data-tb-enviar]').forEach(function (b) {
      if (b.dataset.tbListo) return;
      b.dataset.tbListo = '1';
      b.addEventListener('click', function () {
        var f = document.getElementById(b.getAttribute('data-tb-enviar'));
        if (f) f.requestSubmit ? f.requestSubmit() : f.submit();
      });
    });
  }

  /* ---------- Barra fija de compra ---------- */
  function initBarra() {
    var barra = document.querySelector('[data-tb-barra]');
    var ancla = document.querySelector('[data-tb-barra-ancla]');
    if (!barra || !ancla || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (e) {
      var fuera = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
      barra.classList.toggle('tb-barra--on', fuera);
    }).observe(ancla);
  }

  function initTodo(raiz) {
    initReveals(raiz);
    initContadores(raiz);
    initGaleria(raiz);
    initCantidad(raiz);
    initVariantes(raiz);
    initCarrito(raiz);
  }

  document.addEventListener('DOMContentLoaded', function () { initTodo(document); initBarra(); });
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
})();
